module.exports = __webpack_public_path__ + "static/media/NFTY.edadcce6.png";